import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoaderInlineContent from '../LoaderInlineContent';
import { setArticleList } from '../../Actions/ConfigStock.action';
import constants from '../../constants';
import StockLogin from './StockLogin';
import StockDetails from './StockDetails';

const Stock = ({ id, arrayArticleList, isProductPage = false, articleWeight = 0, articleFactorKg = 0 }) => {
  const dispatch = useDispatch();
  const articleStock = useSelector((state) => state.articleStock);

  useEffect(() => {
    if (constants.isAuthenticated && arrayArticleList && arrayArticleList.length > 0) {
      dispatch(setArticleList(arrayArticleList));
    }
  }, [arrayArticleList, dispatch]);

  const stockArticle = useMemo(() => {
    const articlesList = articleStock.articlesList || [];
    return articlesList.find((x) => x.variantSystemId === id);
  }, [articleStock, id]);

  if (!constants.isAuthenticated) {
    return <StockLogin isProductPage={isProductPage} />;
  }

  return (
    <div className='stock'>
      {stockArticle ? (
        <StockDetails
          variantSystemId={id}
          stockArticle={stockArticle}
          articleWeight={articleWeight}
          articleFactorKg={articleFactorKg}
        />
      ) : (
        <LoaderInlineContent length={10} />
      )}
    </div>
  );
};
export default Stock;
